import axios from 'axios';
import AuthService from 'services/Auth';

class Api {
  constructor(resource = '') {
    const apiUrl = process.env.REACT_APP_API_URL;
    this.url = `${apiUrl}/${resource}`;
  }

  list = (params) => {
    return this.buildQuery('get', params);
  };

  get = (id, params = {}) => {
    return this.buildQuery('get', params, id);
  };

  create = (params) => {
    return this.buildQuery('post', params);
  };

  put = (id, params) => {
    return this.buildQuery('put', params, id);
  };

  destroy = (id) => {
    return this.buildQuery('delete', {}, id);
  };

  buildQuery = (method, params = { props: {} }, prefix) => {
    const props = params?.props || {};
    return axios({
      url: this.getFullUrl(prefix),
      method,
      data: params.data,
      params: params.params,
      responseType: params.responseType, // important
      ...props,
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  };

  getFullUrl = (prefix) => {
    return `${this.url}${prefix ? `/${prefix}` : ''}`;
  };
}

export default Api;
